/**
 * Verifica se dois valores monetários são iguais considerando uma tolerância.
 *
 * @param valor1 Primeiro valor.
 * @param valor2 Segundo valor.
 * @param margem Margem de diferença permitida. Padrão: R$ 0,05.
 */
export default function verificaSaoIguaisComMargemErro(
  valor1: number,
  valor2: number,
  margem = 0.05,
): boolean {
  return Math.abs(valor1 - valor2) <= margem;
}
